import { Grid2, Snackbar } from "@mui/material";
import styles from "../DomainHosted.module.scss";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import ModalPopup from "../../../../../../../GlobalComponents/Popup/ModalPopup";

const WpOptions = (props) => {
  const { popupCard, flushStateVariables, data, loading } = props;

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = () => {
    const url = `https://${data}`;
    navigator.clipboard.writeText(url);
    setSnackbarOpen(true);
  };

  return (
    <>
      <ModalPopup
        header={"One last thing!"}
        trigger={popupCard === "wpoptions"}
        backPopup={"Cancel"}
        nextOnClick={() =>
          window.open(
            `https://dbadmin.${process.env.REACT_APP_TEMP_DOMAIN}/`,
            "_blank"
          )
        }
        backOnClick={() => flushStateVariables()}
        nextpopup={"Update"}
        loading={loading}
      >
        <Grid2 className={styles.header}>Update wp_options</Grid2>
        <Grid2 className={styles.wp}>
          <Grid2>https://{data}</Grid2>
          <Grid2 className={styles.copy}>
            <ContentCopyIcon
              style={{ width: "20px", height: "20px" }}
              onClick={() => {
                handleCopy();
              }}
            />
          </Grid2>
        </Grid2>
      </ModalPopup>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Link copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
};

export default WpOptions;
